export class ScrollTo {
    static top() {
        if (document.documentElement) {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        }
    }

    static element(containerSelector: string, elementSelector: string, smooth?: boolean) {
        const container = document.querySelector(containerSelector);
        const element: any = document.querySelector(elementSelector);

        if (container && element) {
            const offset = element.offsetTop - 50;

            if (offset > container.clientHeight / 2) {
                if (smooth) {
                    const speed = 300;
                    const movingFrequency = 15;

                    const hopCount = speed / movingFrequency;
                    const gap = offset / hopCount;

                    for (let i = 1; i <= hopCount; i++) {
                        (function () {
                            setTimeout(function () { container!.scrollTop += gap; }, movingFrequency * i);
                        })();
                    }
                } else {
                    container.scrollTop = offset;
                }
            }
        }
    }
}
